import { z } from 'zod';
import { BillingSubscriptionCategory, enumParser, recurringIntervals, } from '#validation';
export const detailsSchema = z.object({
    id: z.number(),
    name: z.string(),
    description: z.string(),
    gbPerUser: z.number(),
    pricePerUser: z.number(),
    canSelect: z.boolean(),
    type: z.enum(recurringIntervals),
    category: enumParser(BillingSubscriptionCategory),
});
export const SubscriptionPlanDetailsSchema = z.object({
    details: z.array(detailsSchema),
    currenPlanId: z.number(),
    currentPlanType: z.enum(recurringIntervals),
    currency: z.enum(['usd']),
    unitPriceDiscount: z.number(),
    features: z.object({
        essentialFeatures: z.object({
            title: z.string(),
            members: z.object({
                title: z.string(),
                starter: z.string(),
                business: z.string(),
                enterprise: z.string(),
            }),
            storageCapacity: z.object({
                title: z.string(),
                starter: z.string(),
                business: z.string(),
                enterprise: z.string(),
            }),
            fileSizeLimit: z.object({
                title: z.string(),
                starter: z.string(),
                business: z.string(),
                enterprise: z.string(),
            }),
            /** @deprecated no longer rendered; kept for older client compatibility */
            uploadSpeed: z.object({
                title: z.string(),
                starter: z.string(),
                business: z.string(),
                enterprise: z.string(),
            }),
            highPerformanceStorage: z.object({
                title: z.string(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.boolean(),
            }),
            zeroKnowledgeSecurity: z.object({
                title: z.string(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.boolean(),
            }),
            /** @deprecated no longer rendered; kept for older client compatibility */
            multipleFilespaces: z.object({
                title: z.string(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.boolean(),
            }),
            multipleFilespacesLimit: z.object({
                title: z.string(),
                starter: z.string(),
                business: z.string(),
                enterprise: z.string(),
            }),
            cloudStorageProvider: z.object({
                title: z.string(),
                starter: z.string(),
                business: z.string(),
                enterprise: z.string(),
            }),
            storageOverageCost: z.object({
                title: z.string(),
                starter: z.string(),
                business: z.object({
                    monthly: z.string(),
                    annual: z.string(),
                }),
                enterprise: z.string(),
            }),
        }),
        memberAccess: z.object({
            title: z.string(),
            /** @deprecated no longer rendered; kept for older client compatibility */
            sharingAndPermissions: z.object({
                title: z.string(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.boolean(),
            }),
            accessControl: z.object({
                title: z.string(),
                tooltip: z.string().optional(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.boolean(),
            }),
            multipleAdmins: z.object({
                title: z.string(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.object({
                    message: z.string(),
                }),
            }),
            sso: z.object({
                title: z.string(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.object({
                    message: z.string(),
                }),
            }),
            /** @deprecated no longer rendered; kept for older client compatibility */
            groups: z.object({
                title: z.string(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.boolean(),
            }),
        }),
        advanced: z.object({
            title: z.string(),
            snapshotRecovery: z.object({
                title: z.string(),
                starter: z.boolean(),
                business: z.number(),
                enterprise: z.string(),
            }),
            /** @deprecated no longer rendered; kept for older client compatibility */
            globalSettings: z.object({
                title: z.string(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.object({
                    message: z.string(),
                }),
            }),
            ownStorage: z.object({
                title: z.string(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.boolean(),
            }),
            auditTrail: z.object({
                title: z.string(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.boolean(),
            }),
            developerTools: z.object({
                title: z.string(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.boolean(),
            }),
        }),
        guestAccess: z.object({
            title: z.string(),
            folderAndFileSharing: z.object({
                title: z.string(),
                tooltip: z.string().optional(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.boolean(),
            }),
            activeGuestLinks: z.object({
                title: z.string(),
                tooltip: z.string().optional(),
                starter: z.string(),
                business: z.string(),
                enterprise: z.string(),
            }),
            guestLinkExpiration: z.object({
                title: z.string(),
                tooltip: z.string().optional(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.boolean(),
            }),
        }),
        service: z.object({
            title: z.string(),
            support: z.object({
                title: z.string(),
                starter: z.string(),
                business: z.string(),
                enterprise: z.string(),
            }),
            onboarding: z.object({
                title: z.string(),
                starter: z.boolean(),
                business: z.boolean(),
                enterprise: z.boolean(),
            }),
        }),
    }),
});
